import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Nosotros from "../pages/nosotros/page";
import Servicios from "../pages/servicios/page";
import Compraventa from "../pages/compraventa/page";
import Contacto from "../pages/contacto/page";
import Admin from "../pages/admin/page";
import Social from "../pages/social/page";
import AvisoLegal from "../pages/aviso-legal/page";
import Calculadora from "../pages/calculadora/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/nosotros", element: <Nosotros /> },
  { path: "/servicios", element: <Servicios /> },
  { path: "/compraventa", element: <Compraventa /> },
  { path: "/contacto", element: <Contacto /> },
  { path: "/social", element: <Social /> },
  { path: "/admin", element: <Admin /> },
  { path: "/aviso-legal", element: <AvisoLegal /> },
  { path: "/calculadora", element: <Calculadora /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
